import { useEffect } from 'react';

// The admin panel and the tenant portal are two separate installable "apps"
// sharing one origin/index.html, so they can't each have a fixed manifest
// link — whichever manifest is referenced in <head> at the moment the
// browser's "Add to Home Screen" runs is the one it reads. Swap it to match
// whichever app the visitor is actually in.
export default function usePwaManifest(href) {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    if (link) link.setAttribute('href', href);
  }, [href]);
}
